module.exports = __webpack_public_path__ + "static/media/element-video-quem-somos.30200abd.svg";